export default __webpack_public_path__ + "media/music/5b457b6bc669a9eb1f06b2425150293e.mp3";